import { useEffect } from 'react';
import { useAppDispatch } from 'shared/hooks';
import { getInfrastructureCategories } from 'shared/thunks/infrastructure';

export const useInfrastructureCategoriesRequest = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getInfrastructureCategories());
  }, [dispatch]);
};
